import { makeStyles } from '@material-ui/core';

export default makeStyles(theme => ({
  container: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  field: {
    '& .MuiInputBase-root.Mui-disabled': {
      backgroundColor: '#ECEFF1',
    },
    width: '100%',
    marginBottom: theme.spacing(3),
    '& fieldset': {
      borderColor: theme.palette.colors.border,
    },
    '& label': {
      position: 'relative',
      transform: 'none',
      fontSize: 12,
      marginBottom: theme.spacing(1),
      color: '#90A4AE',
    },
    '& input': {
      height: '100%',
      padding: [0, 14],
    },
    [theme.breakpoints.up('mobile')]: {
      marginBottom: theme.spacing(2),
      width: 500,
    },
  },
  button: {
    width: '100%',
    [theme.breakpoints.up('mobile')]: {
      width: 300,
    },
  },
}));



// WEBPACK FOOTER //
// ./src/components/LoanOfficerSettings/components/AutoFollowupsMessages/components/AutoFollowupsMessagesForm/useStyles.js